import {
  selectedStatesAlpha,
  selectedStates,
  eventCode,
  multiCert,
  selectedInsuranceFunds,
  selectedCharterTypes,
  selectedTransactionTypes,
  activeStatus,
} from "../../refdata/FilterOptions";
import { FormSelectChoice } from "../../interfaces";

interface filterChoicesInterface {
  [key: string]: any[];
}

export const allValuesForFilter = (filterName: string) => {
  if (filterChoices[filterName]) {
    return filterChoices[filterName].map((fc: FormSelectChoice) => fc.value);
  } else {
    return null;
  }
};

export const filterChoices: filterChoicesInterface = {
  selectedStatesAlpha,
  selectedStates,
  eventCode,
  multiCert,
  selectedInsuranceFunds,
  selectedCharterTypes,
  selectedTransactionTypes,
  activeStatus,
};
